import styled from "@emotion/styled";
import { ChatAlarmSettingMenu } from "@/frameworks/core/components";
import { Menu } from "@/frameworks/designStuff/components";

export const SubMenu = styled(Menu)`
	background-color: ${({ theme }) => theme.colors.neutral_00_100};
	z-index: 3;
`;

export const MenuItem = styled(Menu.Item)`
	width: 100%;
	border-radius: 8px;
	cursor: pointer;
	&:hover {
		background-color: ${({ theme }) => theme.colors.secondary_80_8};
	}
	.buttonText {
		width: 100%;
		text-align: left;
	}
	button {
		&:hover {
			background: none;
		}
	}
`;

export const AlarmSettingMenu = styled(ChatAlarmSettingMenu)`
	width: 100%;
	border-radius: 8px;
	cursor: pointer;
	&:hover {
		background-color: ${({ theme }) => theme.colors.secondary_80_8};
	}
	.buttonText {
		width: 100%;
		text-align: left;
	}
	button {
		&:hover {
			background: none;
		}
	}
`;
